import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import withLoading, { WithLoadingPropTypes } from 'hocs/withLoading';

import { useEffectSafeStrictMode } from 'hooks/useEffectSafeStrictMode';

import { getLoanApplicationRoleAssignmentsHistoryAction } from 'store/loanApplications/actions';

import { HistoryTable } from '../../sharedComponents';

import { loanRolesHistoryConfig } from './LoanRolesHistory.config';

const LoanRolesHistory = ({ isLoading, setIsLoading }) => {
  const dispatch = useDispatch();

  const [data, setData] = useState([]);
  const [isError, setIsError] = useState(false);

  const fetchData = useCallback(() => {
    setIsLoading(true);
    setIsError(false);

    dispatch(getLoanApplicationRoleAssignmentsHistoryAction())
      .then(data => setData(data))
      .catch(() => setIsError(true))
      .finally(() => setIsLoading(false));
  }, [dispatch, setIsLoading]);

  useEffectSafeStrictMode(() => {
    fetchData();
  }, [fetchData]);

  return (
    <HistoryTable
      config={loanRolesHistoryConfig}
      data={data}
      fetchData={fetchData}
      isError={isError}
      isLoading={isLoading}
    />
  );
};

LoanRolesHistory.propTypes = {
  ...WithLoadingPropTypes,
};

export default withLoading(LoanRolesHistory);
